/**
 * I18-T.1: i18n barrel export.
 *
 * Usage:
 *   import { useTranslation, I18nProvider } from "@/i18n";
 *   import { MSG } from "@ease/shared/i18n/message-keys";
 *
 *   const { t, locale, setLocale } = useTranslation();
 *   <span>{t(MSG.nav.dashboard)}</span>
 */
import { useContext } from "react";

import { I18nContext, I18nProvider, type SupportedLanguage } from "./i18n-provider";

function useTranslation() {
  const ctx = useContext(I18nContext);
  return {
    t: ctx.t,
    locale: ctx.locale,
    setLocale: ctx.setLocale,
    isReady: ctx.isReady,
  };
}

export { useTranslation, I18nProvider };
export type { SupportedLanguage };
